import { Button } from '@yandex-int/hr-components/Button/desktop/bundle';
import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    sendEmoji,
    toggleEmojies,
    selectIsVideoOnline,
    showUserEmoji,
    selectUserEmoji,
} from 'ducks/emojies';
import { cnKhEmojies } from './KhEmojies.cn';
import { i18n } from '../KhStreamScreen/KhStreamScreen.translations';

import './KhEmojies.css';

import Goose from './goose.png';
import SpecialEmoji from './specialEmoji.png';
import { emojies, emojiesCount, isSpecialEmojiActive, specialEmojiIndex } from './utils';

export const KhEmojies = ({ className }: { className: string }) => {
    const debounceTimeout = useRef<number>(0);
    const [isPopupVisible, setIsPopupVisible] = useState<boolean>(false);
    const buttonRef = useRef(null);
    const dispatch = useDispatch();
    const isOnline = useSelector(selectIsVideoOnline);
    const userEmoji = useSelector(selectUserEmoji);

    const openPopup = () => setIsPopupVisible(true);
    const closePopup = () => setIsPopupVisible(false);

    const onEmojiClick = (emoji: string) => {
        let emojiIndex = emojies.indexOf(emoji);

        if (emoji === 'specialEmoji') {
            emojiIndex = specialEmojiIndex;
        }

        dispatch(toggleEmojies(true));
        dispatch(showUserEmoji(null));
        dispatch(showUserEmoji(emojiIndex));

        setTimeout(() => {
            dispatch(showUserEmoji(null));
        }, 100);

        if (debounceTimeout.current) {
            return;
        }
        dispatch(sendEmoji(emojiIndex));

        debounceTimeout.current = 1;

        setTimeout(() => {
            debounceTimeout.current = 0;
        }, 1000);
    };

    return (
        <div
            onMouseEnter={openPopup}
            onMouseLeave={closePopup}
            onClick={openPopup}
            className={cnKhEmojies(null, [className])}
    >
            <Button
                className={cnKhEmojies('button')}
                theme="pseudo"
                size="s"
                pin="circle-circle"
                innerRef={buttonRef}
                disabled={!isOnline}
                title={isOnline ? '' : i18n('emoji.disabled')}
      >
                {emojies.slice(1, 4).join(' ')}
            </Button>
            {
                <div
                    className={cnKhEmojies('content', {
                        visible: isPopupVisible && isOnline,
                        busy: userEmoji !== null,
                    })}
        >
                    {emojies.slice(0, emojiesCount).map((e, i) =>
                        i === 0 ? (
                            <>
                                <div
                                    key={e}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                >
                                    <img
                                        width="21px"
                                        height="21px"
                                        className={cnKhEmojies('emoji', {
                                            selected: userEmoji === i,
                                        })}
                                        onClick={event => {
                                            event.stopPropagation();
                                            event.preventDefault();

                                            onEmojiClick(e);
                                        }}
                                        key={e}
                                        src={Goose}
                                        alt=""
                                    />
                                </div>
                                {isSpecialEmojiActive &&
                                <div
                                    key={e}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                >
                                    <img
                                        width="21px"
                                        height="21px"
                                        className={cnKhEmojies('emoji', {
                                            selected: userEmoji === specialEmojiIndex,
                                        })}
                                        onClick={event => {
                                            event.stopPropagation();
                                            event.preventDefault();
                                            onEmojiClick('specialEmoji');
                                        }}
                                        key="specialEmoji"
                                        src={SpecialEmoji}
                                        alt=""
                                    />
                                </div>
                                }
                            </>
                        ) : (
                            <span
                                className={cnKhEmojies('emoji', {
                                    selected: userEmoji === i,
                                })}
                                onClick={event => {
                                    event.stopPropagation();
                                    event.preventDefault();

                                    onEmojiClick(e);
                                }}
                                key={e}
              >
                                {e}
                            </span>
                        ),
                    )}
                </div>
      }
        </div>
    );
};
